import { createApp } from 'vue'

import Loading from '@/components/Ui/Loading/Loading.vue'

export default {
  loading: null,
  install(Vue) {
    if (this.loading) {
      // prevent duplicate loading
      Vue.config.globalProperties.$loading = this.loading
      return
    }
    let instance = createApp(Loading)
    let parent = document.createElement('div')
    let bodyDom = document.body
    // append to body
    bodyDom.appendChild(parent)
    this.loading = instance.mount(parent)

    Vue.config.globalProperties.$loading = this.loading
  }
}
